/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZip = createReactComponent("zip", "IconZip", [
  ["path", { d: "M16 16v-8h2a2 2 0 1 1 0 4h-2", key: "svg-0" }],
  ["path", { d: "M12 8v8", key: "svg-1" }],
  ["path", { d: "M4 8h4l-4 8h4", key: "svg-2" }]
]);

export { IconZip as default };
//# sourceMappingURL=IconZip.js.map
